import i18n from 'i18next';
import { AdditionalServicesFragment, CheckinOrderFragment, GdsServiceProductStatus } from '@websky/graphql';
import { UnconfirmedService, UnconfirmedServicesMap } from './types';
import { SegmentId } from 'types';

const UNCONFIRMED_STATUSES = [
	GdsServiceProductStatus.Rejected,
	GdsServiceProductStatus.Canceled,
	GdsServiceProductStatus.Requested
];

export const getUnconfirmedServices = (order: CheckinOrderFragment): UnconfirmedServicesMap => {
	const servicesByIdMap = new Map<string, AdditionalServicesFragment['gdsServices']['services'][0]>();

	order.additionalServices?.gdsServices?.services?.forEach(service => {
		servicesByIdMap.set(service.id, service);
	});

	const unconfirmedServicesMap: UnconfirmedServicesMap = new Map();

	order.travellers.forEach(traveller => {
		traveller.services.gdsServices?.services?.forEach(service => {
			service.segmentIds?.forEach(segmentId => {
				const hasUnconfirmedProduct = service.products.some(product =>
					UNCONFIRMED_STATUSES.includes(product.status)
				);

				if (hasUnconfirmedProduct) {
					service.products.forEach(product => {
						const status = product.status;
						const travellerSegmetServices =
							unconfirmedServicesMap.get(status)?.get(traveller.id) ||
							new Map<SegmentId, UnconfirmedService[]>();
						const segmentServices = travellerSegmetServices.get(segmentId) || [];

						segmentServices.push({
							name: servicesByIdMap.get(service.serviceId)?.name ?? '',
							serviceId: service.serviceId,
							count: service.count - service.confirmedCount
						});

						travellerSegmetServices.set(segmentId, segmentServices);

						const statusServicesMap = unconfirmedServicesMap.get(status) || new Map();
						statusServicesMap.set(traveller.id, travellerSegmetServices);

						unconfirmedServicesMap.set(status, statusServicesMap);
					});
				}
			});
		});

		traveller.services?.seats?.forEach(seat => {
			const segmentId = seat.segment?.id;

			if (UNCONFIRMED_STATUSES.includes(seat.product?.status)) {
				const status = seat.product?.status;
				const travellerSegmetServices =
					unconfirmedServicesMap.get(status)?.get(traveller.id) || new Map<SegmentId, UnconfirmedService[]>();
				const segmentServices = travellerSegmetServices.get(segmentId) || [];

				segmentServices.push({
					name: `${i18n.t('Checkin:Seat')} ${seat.seat?.number}`,
					serviceId: seat.seat?.seatService?.id,
					count: null
				});

				travellerSegmetServices.set(segmentId, segmentServices);
				const statusMap = unconfirmedServicesMap.get(status) || new Map();
				statusMap.set(traveller.id, travellerSegmetServices);
				unconfirmedServicesMap.set(status, statusMap);
			}
		});
	});

	return unconfirmedServicesMap;
};

export const hasRequestedServices = (unconfirmedServices: UnconfirmedServicesMap) =>
	unconfirmedServices.has(GdsServiceProductStatus.Requested);

export const REMOVABLE_STATUSES = [GdsServiceProductStatus.Canceled, GdsServiceProductStatus.Rejected];
